var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drawer"},[_c('div',{staticClass:"drawer__dismisser",on:{"click":_vm.dismiss}}),_vm._v(" "),_c('div',{staticClass:"drawer__content"},[_vm._t("default",[_vm._v("\n      Content slot\n    ")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb8969ec","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/Drawer.vue
// module id = 713
// module chunks = 0